import { useCallback, useEffect, useState } from 'react';
import { Map as OlMap } from 'ol';
import { fromLonLat, get as getProjection } from 'ol/proj';
import { Coordinate } from 'ol/coordinate';
import { JGAMap } from '../libs/Map';
import classNames from 'classnames';

const CoordToAddr = ({
  jgaMap,
  sggName,
  emdName,
  emdList,
  callAddress,
  callCoord,
}: {
  sggName: string;
  emdName: string;
  emdList: Array<{
    // 동 코드
    emd_nm: string;
    emd_cd: string;
    sgg_cd: string;
    sgg_nm: string;
  }>;
  jgaMap: JGAMap;
  callAddress: any;
  callCoord: (emdCd: string) => void;
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!jgaMap) return;
    jgaMap.mapRef.current.on('moveend', () => {
      const center = jgaMap.getCenterCoord();
      callAddress(center);
    });
  }, [jgaMap]);

  const openHandler = (emd_cd: string) => {
    callCoord(emd_cd);
    setOpen(false);
  };

  return (
    <article className="mapPositionArea">
      <ul className="mapPositionList">
        {/* <li>
          <div className="mapPositionTit">제주특별자치도</div>
        </li> */}
        {/* <!-- on : 셀렉트박스를 노출할 경우 추가 --> */}
        <li>
          <div className="mapPositionTit">{sggName}</div>
          {/* <!-- mapPositionSelect : 지역 셀렉트창 (시군) --> */}
          <ul className="mapPositionSelect">
            <li>서귀포시</li>
            <li>제주시</li>
          </ul>
        </li>
        {/* <!-- on : 셀렉트박스를 노출할 경우 추가 --> */}
        <li >
          <div
            className="mapPositionTit"
            onClick={() => setOpen((prev) => !prev)}
          >
            {emdName}
          </div>
          <ul className="mapPositionSelect">
            {emdList &&
              emdList.map((emd) => (
                <li
                  onClick={() => openHandler(emd.emd_cd)}
                  key={emd.emd_cd}
                >
                  {emd.emd_nm}
                </li>
              ))}
          </ul>
        </li>
      </ul>
    </article>
  );
};

export default CoordToAddr;
